//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class FeatureInputTypeService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[FeatureInputType.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/store/feature-input-type/detail', {'params':params});
	};

	//GeneratorFlag:[FeatureInputType.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/store/feature-input-type/list', {'params':params});
	};

//GeneratorFlag:[NewAction]
}